// 区块链安全事件（来源 DefiLlama，经自己的 /api/incidents 缓存 60 分钟）
const LS_KEY = 'musesec-incidents-cache'
let promise = null
let at = 0

function readLocal() {
  try { return JSON.parse(localStorage.getItem(LS_KEY) || 'null') } catch (e) { return null }
}

async function load() {
  const res = await fetch('/api/incidents', { headers: { Accept: 'application/json' } })
  if (!res.ok) throw new Error('HTTP ' + res.status)
  const data = await res.json()
  if (!Array.isArray(data.items) || !data.items.length) throw new Error('empty')
  try { localStorage.setItem(LS_KEY, JSON.stringify(data)) } catch (e) { /* ignore */ }
  return data
}

// 同一页面多个组件共用一次请求；5 分钟内重复调用直接复用
export function fetchIncidents(force = false) {
  if (!force && promise && Date.now() - at < 5 * 60 * 1000) return promise
  at = Date.now()
  promise = load().catch(err => {
    promise = null
    const last = readLocal()
    if (last && Date.now() - last.updatedAt < 7 * 24 * 3600 * 1000) return last
    throw err
  })
  return promise
}

// 金额：中文用 万 / 亿，英文用 K / M / B
export function formatUsd(n, lang) {
  if (typeof n !== 'number' || !isFinite(n) || n <= 0) return lang === 'en' ? 'Undisclosed' : '金额未披露'
  if (lang === 'en') {
    if (n >= 1e9) return '$' + (n / 1e9).toFixed(2).replace(/\.?0+$/, '') + 'B'
    if (n >= 1e6) return '$' + (n / 1e6).toFixed(n >= 1e8 ? 0 : 1).replace(/\.0$/, '') + 'M'
    if (n >= 1e3) return '$' + Math.round(n / 1e3) + 'K'
    return '$' + Math.round(n)
  }
  if (n >= 1e8) return '$' + (n / 1e8).toFixed(n >= 1e9 ? 0 : 1).replace(/\.0$/, '') + ' 亿'
  if (n >= 1e4) return '$' + (n / 1e4).toFixed(n >= 1e6 ? 0 : 1).replace(/\.0$/, '') + ' 万'
  return '$' + Math.round(n)
}
